import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import Routes from "../config/routes";
import Header from "./globals/Header";

class App extends Component {
  render() {
    return (
      <div className="App">
        <Header />
        <div className="Page">
          <Routes />
        </div>
      </div>
    );
  }
}

export default withRouter((App));



// WEBPACK FOOTER //
// ./src/components/App.js